import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PILLARS } from '@/mocks/pillars';

export default function PillarArticles() {
  const { t } = useTranslation();

  return (
    <section id="articles" className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            {t('pillars.title')}
          </h2>
          <p className="mt-3 text-sm text-foreground-600 md:text-base">{t('pillars.subtitle')}</p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {PILLARS.map((pillar) => (
            <Link
              key={pillar.slug}
              to={`/article/${pillar.slug}`}
              className="group flex flex-col overflow-hidden rounded-xl border border-background-200/70 bg-background-50 transition-transform hover:-translate-y-1 cursor-pointer"
            >
              <div className="aspect-[16/10] w-full overflow-hidden bg-background-100">
                <img
                  src={pillar.image}
                  alt={t(`pillars.${pillar.slug}.breadcrumb`)}
                  title={`${t(`pillars.${pillar.slug}.breadcrumb`)} — USFans Spreadsheet`}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <span className="inline-flex items-center gap-1.5 text-xs font-medium text-foreground-500">
                  <i className="ri-time-line" />
                  {t(`pillars.${pillar.slug}.read_time`)}
                </span>
                <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-900">
                  {t(`pillars.${pillar.slug}.breadcrumb`)}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                  {t(`pillars.${pillar.slug}.excerpt`)}
                </p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 group-hover:text-primary-700">
                  {t('pillars.read')}
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}